import React, { useEffect, useState } from 'react'
import { toggleSidebar } from '../../../redux/components/components-slice'
import { useDispatch, useSelector } from 'react-redux'
import DashboardLayout from '../../../components/layouts/dashboard'
import Button from '../../../components/button'
import { useHistory } from 'react-router-dom'
import FormSelect from '../../../components/form-select'
import WalletSVG from '../../../assets/svg/new-dashboard-wallet.svg'
import PayinSVG from '../../../assets/svg/new-payin.svg'
import Purchase from '../../../assets/svg/purchase-new.svg'

import PayoutSVG from '../../../assets/svg/new-payout.svg'
import VendorSVG from '../../../assets/svg/new-vendor.svg'
import Vendor from '../../../assets/svg/vendor-two.svg'

import InvoiceSVG from '../../../assets/svg/invoice-new.svg'
import { useGetSpendDashboard } from '../../../redux/dashboard/hook'
import LoadingBar from '../../../components/loader-bar'
import { useHelpMeOnboard } from '../../../redux/company/hook'
import { formatNumber } from '../../../utils/functions'
import SpendChart from '../../../components/payroll-section/dashboard/spend-chart'
import SpendOverviewChart from '../../../components/payroll-section/dashboard/spend-overview-chart'
import moment from 'moment'
import SelectVendorPayOption from '../../../components/modal/spend-management/vendor/select-vendor-pay-option'

const SpendDashboardPage = () => {
  useEffect(() => {}, [])

  const dispatch = useDispatch()
  const history = useHistory()
  const { user } = useSelector((state) => state.userSlice)

  const { data: dashboard, isLoading: dashboardLoading } =
    useGetSpendDashboard()

  const [donutData, setDonutData] = useState(null)
  const [spendStat, setspendStats] = useState(null)

  const [showSelectVendorPayOption, setShowSelectVendorPayOption] =
    useState(false)

  const { mutateAsync: helpMeOnboard, isLoading: onboardLoading } =
    useHelpMeOnboard()

  useEffect(() => {
    if (dashboard) {
      updatePayrollOverview()
      updatespendStats()
    }
    updatePayrollOverview()
    updatespendStats()
  }, [dashboard])

  useEffect(() => {
    if (window.innerWidth < 851) {
      dispatch(toggleSidebar())
    }
  }, [])

  const [sortOption, setSortOption] = useState('Last 12 months')

  const sortOptions = [{ value: 'Last 12 months', label: 'Last 12 months' }]


  function updatePayrollOverview() {
    let data = {
      data: {
        labels: ['Inflow', 'Outflow', 'Charges'],
        options: {
          plugins: {
            legend: {
              display: false,
            },
          },
        },
        datasets: [
          {
            cutout: '70%',
            label: '# of Votes',
            data: [dashboard?.inflows, dashboard?.outflows, dashboard?.charges],
            backgroundColor: ['#3943B7', '#ef0b0b', 'rgba(68, 175, 105, 1)'],
          },
        ],
      },
      legends: [
        {
          title: 'Inflows',
          color: 'bg-secondary-2',
        },
        {
          title: 'Outflows',
          color: 'bg-[#ef0b0b]',
        },
        {
          title: 'Charges',
          color: 'bg-[#0d5225]',
        },
      ],
      total: formatNumber(
        parseInt(dashboard?.inflows) +
          parseInt(dashboard?.outflows) +
          parseInt(dashboard?.charges),
        2
      ),
    }

    setDonutData(data)
  }

  function updatespendStats() {
    let data = {
      data: {
        labels: [],
        datasets: [
          {
            label: 'Inflow',
            data: [],
            backgroundColor: '#000000',
            borderColor: '#000000',
            borderWidth: 1,
          },
          {
            label: 'Outflow',
            data: [],
            backgroundColor: '#ef0b0b',
            borderColor: '#ef0b0b',
            borderWidth: 1,
          },
        ],
      },
    }

    // Process inflow data
    let inflowAmounts = []
    let outflowAmounts = []
    let months = []

    // Make sure we have the data
    const inflowData = dashboard?.lastSixMonths
      ? [...dashboard.lastSixMonths]
      : []
    const outflowData = dashboard?.lastSixMonthsOutflows
      ? [...dashboard.lastSixMonthsOutflows]
      : []

    // Reverse to get chronological order (oldest to newest)
    inflowData.reverse()
    outflowData.reverse()

    // Process inflow data
    inflowData.forEach((element) => {
      inflowAmounts.push(element.amount)
      months.push(moment(element.month + '-01').format('MMMM YYYY'))
    })

    // Process outflow data
    outflowData.forEach((element) => {
      outflowAmounts.push(element.amount)
    })

    data.data.labels = months
    data.data.datasets[0].data = inflowAmounts
    data.data.datasets[1].data = outflowAmounts

    let maxTotal = 0
    for (let i = 0; i < inflowAmounts.length; i++) {
      const total = inflowAmounts[i] + outflowAmounts[i]
      if (total > maxTotal) maxTotal = total
    }

    // Set appropriate step size based on the max value
    let stepSize
    if (maxTotal >= 1000000) {
      stepSize = 500000 // 0.5M steps
    } else if (maxTotal >= 100000) {
      stepSize = 100000 // 100K steps
    } else {
      stepSize = 50000 // 50K steps
    }

    data.options = {
      scales: {
        y: {
          stacked: true,
          max: Math.ceil(maxTotal * 1.1), // 10% padding
          ticks: {
            stepSize: stepSize,
            callback: function (value) {
              if (value === 0) return '₦0'
              if (value >= 1000000) {
                return '₦' + (value / 1000000).toFixed(1) + 'M'
              } else if (value >= 1000) {
                return '₦' + (value / 1000).toFixed(1) + 'K'
              } else {
                return '₦' + value?.toLocaleString() || '0'
              }
            },
            color: '#000',
          },
        },
        x: {
          stacked: true,
        },
      },
    }

    setspendStats(data)
  }
  const onboard = () => {
    helpMeOnboard()
  }

  return (
    <DashboardLayout title='Spend Dashboard'>
      {showSelectVendorPayOption ? (
        <SelectVendorPayOption
          isOpen={showSelectVendorPayOption}
          closeModal={() => setShowSelectVendorPayOption(false)}
        />
      ) : null}
      <div className='flex flex-col md:flex-row justify-between items-center'>
        <div className='flex flex-col'>
          <span className='header-3'> Welcome {user?.first_name},</span>
          <span className='text-[14px] text-gray-500'>
            Need help getting started? Let’s help you onboard
          </span>
        </div>
      </div>
      {dashboardLoading ? (
        <div className='flex flex-col w-full text-center justify-center pb-[25px] pt-[15px]'>
          <LoadingBar loading={dashboardLoading} />
        </div>
      ) : (
        <div className='flex flex-col gap-4 mt-3'>
          <div className='flex w-full py-2.5 border'>
            <div className='flex flex-col items-center justify-center w-full gap-2 md:border-r border-gray-300'>
              <span className='font-medium text-color-gray !text-sm text-center'>
                WALLET BALANCE
              </span>
              <span className='font-bold text-[18px]'>
                NGN{' '}
                {dashboard?.walletBalance
                  ? formatNumber(dashboard.walletBalance, 2)
                  : '0.00'}
              </span>
            </div>
            <div className='flex flex-col justify-center items-center w-full gap-2 '>
              <span className='font-medium text-color-gray !text-sm text-center'>
                SCHEDULED PAYMENTS
              </span>
              <span className='font-bold text-[18px]'>
                NGN{' '}
                {dashboard?.scheduled_payments
                  ? formatNumber(dashboard.scheduled_payments, 2)
                  : '0.00'}
              </span>
            </div>
          </div>
          <div className='flex flex-col bg-color-white md:flex-row justify-between h-fit rounded-md border'>
            <div className='flex flex-col p-4 md:w-[70%] w-full md:border-r border-r-0 gap-4 h-[500px] border-gray-200'>
              <div className='w-[100%] md:w-[100%] flex flex-col h-[500px] gap-2'>
                <div className='flex justify-between items-center pl-4 pr-3'>
                  <span className='p2'>Spend stats</span>
                  <div className='hidden md:flex flex-row items-center gap-2'>
                    <div className='bg-spend-primary-1 w-[10px] h-[10px] rounded-[10px] pr-2'></div>
                    <span className='text-[13px] font-semibold'>Inflows</span>
                    <div className='bg-[#ef0b0b] w-[10px] h-[10px] rounded-[10px] pr-2 ml-4'></div>
                    <span className='text-[13px] font-semibold'>Outflow</span>
                  </div>
                  <div className='flex items-center h-[27px]'>
                    <FormSelect
                      defaultValue={sortOption}
                      options={sortOptions}
                      onChange={(selected) => {
                        setSortOption(selected)
                      }}
                      type='default'
                      extraClass='h-[27px] w-[140px] !text-[12px]'
                    />
                  </div>
                </div>
                <div className='h-full w-[100%]'>
                  {spendStat ? <SpendChart data={spendStat} /> : null}
                </div>
              </div>
            </div>
            <div className='flex flex-col md:w-[30%] w-full'>
              <hr className='md:hidden divider md:-mt-2 md:mb-1' />
              <div className='flex items-center justify-between py-2 w-[80%] mx-auto'>
                <div className='flex flex-col gap-2 '>
                  <span className='font-bold text-[10px] leading-[12px] text-color-gray flex flex-col text-center'>
                    CUSTOMERS
                  </span>
                  <span className='font-semibold text-[20px]'>
                    {dashboard?.customer_count
                      ? formatNumber(dashboard.customer_count, 2)
                      : '0'}
                  </span>
                </div>
                <div className='flex items-center justify-center min-w-[30%] min-h-[60px]'>
                  <img src={WalletSVG} alt='' height={'50px'} width={'50px'} />
                </div>
              </div>
              <hr className='divider md:-mt-2 md:-mb-1' />
              <div className='flex items-center justify-between py-2 w-[80%] mx-auto'>
                <div className='flex flex-col gap-2 '>
                  <span className='font-bold text-[10px] leading-[12px] text-color-gray flex flex-col text-center'>
                    VENDORS
                  </span>
                  <span className='font-semibold text-[20px]'>
                    {dashboard?.vendor_count
                      ? formatNumber(dashboard.vendor_count, 2)
                      : '0'}
                  </span>
                </div>
                <div className='flex items-center justify-center min-w-[30%] min-h-[60px]'>
                  <img src={VendorSVG} alt='' height={'50px'} width={'50px'} />
                </div>
              </div>
              <hr className='divider md:-mt-2 md:-mb-1' />
              <div className='flex items-center justify-between py-2 w-[80%] mx-auto'>
                <div className='flex flex-col gap-2 '>
                  <span className='font-bold text-[10px] leading-[12px] text-color-gray flex flex-col '>
                    TOTAL PAYIN
                  </span>
                  <span className='font-semibold text-[20px]'>
                    {dashboard?.inflows
                      ? formatNumber(dashboard.inflows, 2)
                      : '0.00'}
                  </span>
                </div>
                <div className='flex items-center justify-center min-w-[30%] min-h-[60px]'>
                  <img src={PayoutSVG} alt='' height={'50px'} width={'50px'} />
                </div>
              </div>
              <hr className='divider md:-mt-2 md:-mb-1' />
              <div className='flex items-center justify-between py-2 w-[80%] mx-auto'>
                <div className='flex flex-col gap-2 '>
                  <span className='font-bold text-[10px] leading-[12px] text-color-gray flex flex-col'>
                    TOTAL PAYOUT
                  </span>
                  <span className='font-semibold text-[20px]'>
                    {dashboard?.outflows
                      ? formatNumber(dashboard.outflows, 2)
                      : '0.00'}
                  </span>
                </div>
                <div className='flex items-center justify-center min-w-[30%] min-h-[60px]'>
                  <img src={PayinSVG} alt='' height={'50px'} width={'50px'} />
                </div>
              </div>
              <hr className='divider md:-mt-2 md:-mb-1' />
              <div className='flex flex-col bg-color-white md:p-4 pt-4 lg:flex-row justify-between md:min-h-[250px] min-h-[250px] w-full mt-3'>
                <SpendOverviewChart data={donutData} />
              </div>
            </div>
          </div>
          <div className='flex md:flex-row flex-col w-full gap-4 mt-2'>
            <div className='flex flex-col px-3 py-2 bg-color-white gap-2 md:w-1/3 w-full rounded-md border'>
              <div className='flex items-center gap-3'>
                <div className='text-[14px]'>Invoices</div>
                <img src={InvoiceSVG} alt='' height={'30px'} width={'30px'} />
              </div>
              <div className='w-full'>
                <Button
                  text='CREATE INVOICE'
                  type='button'
                  theme='primary'
                  className={`h-[40px] px-2 rounded-md  min-w-fit shadow-none`}
                  textClass={'!text-[15px]'}
                  onClick={() => {
                    history.push(`/customers/invoice`)
                  }}
                />
              </div>
            </div>
            <div className='flex flex-col px-3 py-2 bg-color-white gap-2 md:w-1/3 w-full rounded-md border'>
              <div className='flex items-center gap-3'>
                <div className='text-[14px]'>Purchase Orders</div>
                <img src={Purchase} alt='' height={'30px'} width={'30px'} />
              </div>
              <div className='w-full'>
                <Button
                  text='CREATE PURCHASE ORDER'
                  type='button'
                  theme='primary'
                  className={`h-[40px] px-2 rounded-md  min-w-fit shadow-none`}
                  textClass={'!text-[15px]'}
                  onClick={() => {
                    history.push(`/vendors/purchase-order`)
                  }}
                />
              </div>
            </div>
            <div className='flex flex-col px-3 py-2 bg-color-white gap-2 md:w-1/3 w-full rounded-md border'>
              <div className='flex items-center gap-3'>
                <div className='text-[14px]'>Vendors</div>
                <img src={Vendor} alt='' height={'30px'} width={'30px'} />
              </div>
              <div className='w-full'>
                <Button
                  text='PAY VENDOR'
                  type='button'
                  theme='primary'
                  className={`h-[40px] px-2 rounded-md  min-w-fit shadow-none`}
                  textClass={'!text-[15px]'}
                  onClick={() => setShowSelectVendorPayOption(true)}
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </DashboardLayout>
  )
}

export default SpendDashboardPage
